<!--
 * @Author: 汪俊洪
 * @Date: 2025-04-25 13:32:21
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-05-22 17:54:30
 * @Description:
-->
<template>
  <div class="page">
    <div class="content">
      <!-- 主体内容 -->
      <ListCart
        :dataList="[...dataList, ...invalidList]"
        :dataListLoading="loading"
        :activited="activited"
        @refresh="doSearch"
      />
    </div>
  </div>
</template>

<script>
import ListCart from './components/listCart.vue'

export default {
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  components: {
    ListCart
  },
  data () {
    return {
      dataList: [],
      invalidList: [], // 失效列表
      loading: false,
      activited: '1'
    }
  },
  created () {
    if (this.type) {
      this.activited = this.type
    }
    this.doSearch()
  },
  methods: {
    doSearch () {
      this.loading = true
      this.$http
        .get(
          `/front/consumer/shoppingcart/myShoppingCartList/${this.activited}`
        )
        .then(({ data: res }) => {
          this.loading = false
          if (res.code === 0) {
            this.dataList = res.data.available
            this.invalidList = res.data.unavailable
          }
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  height: calc(100vh - 116px);
  padding: 16px 0;
  background: url('~@/assets/img/plc/bg1.png') no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;
}
.content {
  display: flex;
  flex-direction: column;
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  background: #fff;
  overflow: hidden;
  background: url('~@/assets/img/plc/bg2.png') no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;
}
</style>
